import { getCardColor } from '@/dashboard/WordMat/colors';
import { ChalkboardTeacherIcon } from '@phosphor-icons/react';
import { cn } from '@shadcn/lib/utils';

interface LessonPlanPreviewProps {
  id: string;
  className?: string;
}

export default function LessonPlanPreview({
  id,
  className,
}: LessonPlanPreviewProps) {
  const cardColor = getCardColor(id);

  return (
    <div
      className={cn(
        'relative flex items-center justify-center',
        cardColor,
        className,
      )}
    >
      <ChalkboardTeacherIcon
        size={24}
        weight="duotone"
        className="absolute bottom-2 left-2 text-gray-600 opacity-60"
      />
    </div>
  );
}
